import ModelBuilder, { FormFieldsOf, Prefix } from "helpers/ModelBuilder";
import { EntityBase, EntityLike } from "./EntityBase";
import { GuestPayload } from "services/payloads/GuestPayload";
import { addressFields, billingFields } from "./Address";
import { Vehicle } from "./Vehicle";

export class Guest extends EntityBase {
  id: string;
  firstName: string;
  lastName: string;
  fullName: string;
  displayName?: string;
  email: string;
  phone: string;
  address: string;
  address2: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  useMailingAsBilling: boolean;
  billingAddress: string;
  billingAddress2: string;
  billingCity: string;
  billingState: string;
  billingPostalCode: string;
  billingCountry: string;
  // Vehicle info
  vehicleType: string
  vehicleLengthRange: string
  vehicleSlides: string[] = []
  vehicleTowing: string
  vehicleElectrical: string[] = []

  static Model: typeof ModelDefinition;

  static new(object: EntityLike<Guest>) {
    return super.fill(this, object);
  }
}

export type GuestVehicle = Prefix<Vehicle, 'vehicle'>;
export const vehicleFields = ModelBuilder.prefixFields(Vehicle.Model.fields, 'vehicle') as FormFieldsOf<GuestVehicle>;

let fields = ModelBuilder.buildFormFields<Guest>({
  id: null,
  firstName: { label: 'First Name' },
  lastName: { label: 'Last Name' },
  fullName: { label: 'Name' },
  email: { label: 'Email', type: 'email' },
  phone: { label: 'Phone', type: 'tel' },
  ...addressFields,
  useMailingAsBilling: { label: 'Use Mailing Address as Billing Address', type: 'checkbox' },
  ...billingFields,
  ...vehicleFields,
})

fields = ModelBuilder.setRulesToFields(fields, {
  firstName: [{ required: true }],
  lastName: [{ required: true }],
  email: [{ required: true }],
  phone: [{ required: true }],
})

const mapModel = ModelBuilder.buildMapModel<Guest, GuestPayload>((payload) => {
  const model = Guest.new({
    ...payload,
    phone: payload.formattedPhone,
    displayName: [payload.firstName, payload.middleName, payload.lastName].filter(x => Boolean(x)).join(' '),
  });
  return model;
})

const buildPayload = (guest: Guest, parkId: string) => {
  const payload = GuestPayload.new(guest);
  payload.parkId = parkId;
  return payload;
}

class ModelDefinition {
  static fields = fields;
  static mapModel = mapModel;
  static buildPayload = buildPayload;
}
Guest.Model = ModelDefinition;
